import Vue from 'vue'
import { dateLibs } from '../utils'

Vue.filter('formatDate', (value: string) => {
  return value ? dateLibs.formatDateOfApi(value) : ''
})
